export default "__VITE_ASSET__Cd7DuU$r__"